var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { list, primitive } from '../../../utils/serializr/serializr';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { editable, editObservable } from '../../../utils/mobx/decorators/editable';
export class LocationOptions {
    parent = null;
    activity_distribution = [];
    difficulty_distribution = [];
    average_distribution = [];
    relativeknowledge_distribution = [];
    relevanttopics = [];
    constructor() {
        editObservable(this);
    }
    static get serializeInfo() {
        return {
            props: {
                activity_distribution: list(primitive),
                difficulty_distribution: list(primitive),
                average_distribution: list(primitive),
                relativeknowledge_distribution: list(primitive),
                relevanttopics: list(primitive),
            },
        };
    }
}
__decorate([
    editable('ref')
], LocationOptions.prototype, "activity_distribution", void 0);
__decorate([
    editable('ref')
], LocationOptions.prototype, "difficulty_distribution", void 0);
__decorate([
    editable('ref')
], LocationOptions.prototype, "average_distribution", void 0);
__decorate([
    editable('ref')
], LocationOptions.prototype, "relativeknowledge_distribution", void 0);
__decorate([
    editable('ref')
], LocationOptions.prototype, "relevanttopics", void 0);
__decorate([
    memoize
], LocationOptions, "serializeInfo", null);
